import { render, staticRenderFns } from "./view_order.vue?vue&type=template&id=7b32347a&scoped=true"
import script from "./view_order.vue?vue&type=script&lang=js"
export * from "./view_order.vue?vue&type=script&lang=js"
import style0 from "./view_order.vue?vue&type=style&index=0&id=7b32347a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b32347a",
  null
  
)

export default component.exports